/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-simple[_ngcontent-%COMP%]{width:100%}.button-simple[_ngcontent-%COMP%]   .same-line[_ngcontent-%COMP%]{justify-content:center}.glyphicons-calculator[_ngcontent-%COMP%]::before{padding:6px 8px 6px 2px}\n/*# sourceMappingURL=feat-config-nguid.component.css.map*/"];
export { styles as styles };
